import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import LifelineSlider from './LifelineSlider';
import classnames from 'classnames';

import './style.css';

function CreateLifeline({ visible, beaconIndex, onButtonFocus }) {
  return (
    <div
      data-index={beaconIndex}
      className={classnames('section', 'lifelines', {
        'section--visible': visible,
      })}
    >
      <div /* BEACON */ data-index={beaconIndex} className="beacon" />
      <div className="fixed-content-wrapper pointer-events">
        <div className="row">
          <div className="col padding--right">
            <h1 className="fade-in section__header">
              Create a unique
              <br />
              lifeline for a loved one
              <br />
              or yourself.
            </h1>

            <p className="fade-in td1 section__text">
              Answer some simple questions to start building a lifeline that
              celebrates a life. See how your answers create an entirely unique
              shape that will live on in digital memorial. Explore the story
              that we create and discover new insights into their life.
            </p>
            <div className="buttons-wrapper fade-in td2">
              <Button
                size="large"
                variant="tertiary"
                to="/search"
                onFocus={() => {
                  onButtonFocus(beaconIndex);
                }}
              >
                Explore the lifelines
              </Button>
            </div>
          </div>
          <div className="col fade-in td3 col--slider">
            <LifelineSlider paused={!visible} />
          </div>
        </div>
      </div>
    </div>
  );
}

CreateLifeline.propTypes = {
  visible: PropTypes.bool.isRequired,
  beaconIndex: PropTypes.number.isRequired,
};

export default CreateLifeline;
